import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import DashboardLayout from "../components/DashboardLayout";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import { useAuth } from "../contexts/AuthContext";
import { Check, Loader2 } from "lucide-react";

export default function BillingSuccess() {
  const { t } = useI18n();
  const { refreshMe } = useAuth();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    const session_id = params.get("session_id");
    if (!session_id) { setStatus("error"); return; }

    const poll = async () => {
      attempts.current += 1;
      try {
        const res = await api.get(`/billing/status/${session_id}`);
        setData(res.data);
        if (res.data.payment_status === "paid") {
          setStatus("paid");
          refreshMe();
          return;
        }
        if (res.data.status === "expired") { setStatus("expired"); return; }
      } catch (e) {}
      if (attempts.current < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
    // eslint-disable-next-line
  }, []);

  return (
    <DashboardLayout>
      <div className="max-w-xl">
        <div className="card-premium p-10 text-center" data-testid="billing-success-card">
          {status === "checking" ? (
            <>
              <Loader2 className="h-10 w-10 text-[#0A192F] animate-spin mx-auto" />
              <h1 className="mt-4 font-display font-bold text-2xl text-slate-900">{t("billing.checking")}</h1>
            </>
          ) : status === "paid" ? (
            <>
              <div className="h-14 w-14 rounded-full bg-emerald-100 text-emerald-600 mx-auto flex items-center justify-center">
                <Check className="h-7 w-7" />
              </div>
              <h1 className="mt-4 font-display font-bold text-2xl text-slate-900">{t("billing.successTitle")}</h1>
              <p className="mt-2 text-slate-600 text-sm">{t("billing.successSub")}</p>
              <Link to="/dashboard" className="btn-primary inline-block mt-6 rounded-full px-6 py-3 font-semibold" data-testid="billing-go-dash">
                {t("billing.goDash")}
              </Link>
            </>
          ) : (
            <>
              <h1 className="font-display font-bold text-2xl text-slate-900">{t("common.error")}</h1>
              <p className="mt-2 text-slate-600 text-sm">{status}</p>
              <Link to="/pricing" className="btn-primary inline-block mt-6 rounded-full px-6 py-3 font-semibold">
                {t("nav.pricing")}
              </Link>
            </>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
